import { render } from "./SideUser.vue?vue&type=template&id=baec90e2"
import script from "./SideUser.vue?vue&type=script&lang=js"
export * from "./SideUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__